<template>
  <CarouselWidget
    v-if="items.length"
    class="slide-show-section"
    :items="items"
    :itemsToShow="{
      xs: 1,
      sm: 1,
      md: 1,
      lg: 1,
      xl: 1,
    }"
    :gap="0"
    :mouse-drag="false"
  >
    <template #item="{ item }">
      <img
        class="d-block slide-show-section_img"
        :src="xsOnly ? item.mobile : item.desktop"
        width="100%"
      />
    </template>
  </CarouselWidget>
</template>

<script>
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";

export default {
  computed: {
    items() {
      return [
        {
          desktop: require("../../assets/img/slides/01.jpg"),
          mobile: require("../../assets/img/slides/01-mobile.jpg"),
        },
        {
          desktop: require("../../assets/img/slides/02.jpg"),
          mobile: require("../../assets/img/slides/02-mobile.jpg"),
        },
        {
          desktop: require("../../assets/img/slides/03.jpg"),
          mobile: require("../../assets/img/slides/03-mobile.jpg"),
        },
        {
          desktop: require("../../assets/img/slides/04.jpg"),
          mobile: require("../../assets/img/slides/04-mobile.jpg"),
        },
        {
          desktop: require("../../assets/img/slides/05.jpg"),
          mobile: require("../../assets/img/slides/05-mobile.jpg"),
        },
        {
          desktop: require("../../assets/img/slides/06.jpg"),
          mobile: require("../../assets/img/slides/06-mobile.jpg"),
        },
        {
          desktop: require("../../assets/img/slides/07.jpg"),
          mobile: require("../../assets/img/slides/07-mobile.jpg"),
        },
      ];
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  components: {
    CarouselWidget,
  },
};
</script>

<style lang="scss" scoped>
.slide-show-section {
  &_img {
    aspect-ratio: 1920 / 575;
    object-fit: cover;
    -o-object-fit: cover;
    width: 100%;

    @media screen and (max-width: 599.9px) {
      aspect-ratio: 600 / 600;
    }
  }
}
</style>
